import withConfirmationDialogOnClick from './withConfirmationDialogOnClick';

export default withConfirmationDialogOnClick;
